import styled from 'styled-components';


export const ContainerWrapper = styled.div`
    width: 118px;
    height: 118px;
    border-radius: 96px;
    background-color: #6FB7FF;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 5;
    @media (max-width: 1200px) {
        width: 81px;
        height: 81px;
    }

`;

export const TagButton = styled.div`
    width: auto;
    height: auto;
    display: flex;
    display: ${props => props.full && 'block'};
    flex-wrap: nowrap;
    margin: 10px;
    margin-top: 20px;
    position: relative;
    z-index: 0;
    width: 40%;
    width: ${props => props.large && '498px'};
    max-width: 100%;
    height: 77px;
    margin-left: ${props => props.right && '40px'};
    margin-right: ${props => props.left && '40px'};
    width: ${props => props.full && '100%'};

    @media (max-width: 1200px) {
        margin-left: 0;
        margin-right: 0 !important;
    }

    @media (max-width: 600px) {
        width: 100%;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    
    &:hover {
        cursor: pointer;
    }
`;

export const Img = styled.img`
    position: absolute;
    width: 69px;
    height: auto;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    @media (max-width: 1200px) {
        left: 19px;
        width: 44px;
    }
`;

export const Text = styled.div`
    position: absolute;
    left: 133px;
    top: 30px;
    top: ${props => props.full && '37px'};

    width: ${props => props.large && '400px'};
    width: ${props => props.full && '100%'};

    max-width: 100%;
    height: auto;
    text-align: left;

    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #0064BA;
    color: ${props => props.white && 'white'};
    position: relative;
    z-index: 0;

    white-space: nowrap;

    @media (max-width: 1200px) {
        top: 20px;
        left: 90px;
        font-size: 14px;
    }
    strong {
        font-family: 'Lato';
        font-style: normal;
        font-weight: normal;
        font-size: 48px;
        line-height: 70%;
        margin-left: -3px;
        white-space: nowrap;
        @media (max-width: 1200px) {
            font-size: 38px;
            line-height: 28px;
            /* or 28px */
        }
    }
`;


export default TagButton;
